class ChooseSize extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector(".choose-size__button");
    this.addButton = this.querySelector(".choose-size__add-button");
    this.addButtonText = this.addButton.querySelector(".choose-size__add-button-text");
    this.spinner = this.addButton.querySelector(".loading__spinner");
    this.addButtonPrice = this.addButton.querySelector(".choose-size__price");
    this.dropdown = this.querySelector(".choose-size__dropdown");
    this.list = this.querySelector(".choose-size__ul");
    this.productTitle = this.getAttribute("data-title");
    this.productPrefix = this.productTitle.split(" iPhone ")[0];

    this.openClass = "state--active";

    this.button.addEventListener("click", this.onButtonClick.bind(this));
    this.addButton.addEventListener("click", this.onAddButtonClick.bind(this));

    this.querySelectorAll(".choose-size__radio").forEach((radio) => {
      radio.addEventListener("change", this.onRadioChange.bind(this));
    });

    document.addEventListener("click", this.onDocumentClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    this.hideAllLists();
    this.showList();

    const sliderParent = this.closest(".slider");
    if (sliderParent) {
      sliderParent.classList.add("state--active");
    }
  }

  onAddButtonClick(event) {
    event.preventDefault();
  
    if (this.addButton.classList.contains("BIS_trigger")) return;
  
    const selectedRadio = this.querySelector(".choose-size__radio:checked");
  
    this.addButton.classList.add("loading");
    this.addButton.setAttribute("aria-disabled", true);
    const spinner = this.addButton.querySelector(".loading__spinner");
    if (spinner) spinner.classList.remove("hidden");
  
    if (selectedRadio) {
      const variantId = selectedRadio.value;
      const quantity = 1;
  
      fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      })
        .then(() => {
          return fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
        })
        .then((res) => res.json())
        .then((sections) => {
          document.querySelector('cart-drawer')?.renderContents({
            id: this.variantId,
            sections
          });
        })
        .catch((error) => {
          console.error('Error updating cart:', error);
        })
        .finally(() => {
          this.addButton.classList.remove("loading");
          this.addButton.removeAttribute("aria-disabled");
          if (spinner) spinner.classList.add("hidden");
        });
    }
  }

  onRadioChange(event) {
    this.querySelectorAll(".choose-size__radio").forEach((radio) => {
      radio.checked = false;
    });

    event.target.checked = true;
    this.addButton.removeAttribute("disabled");

    const price = event.target.getAttribute("data-price");
    this.addButtonPrice.innerHTML = price;

    this.checkBIS(event);
  }

  checkBIS(event) {
    if (event.target.type !== "radio") return;

    const available = event.target.getAttribute("data-available") === "true";

    if (available) {
      this.addButtonText.textContent = "Add";
      this.addButton.classList.remove("BIS_trigger");
      this.addButton.removeAttribute("data-product-data");
    } else {
      const json = event.target.parentNode.getAttribute("data-json");
      this.addButton.setAttribute("data-product-data", json);
      this.addButton.classList.add("BIS_trigger");
      this.addButtonText.textContent = "Join the waitlist";
    }
  }

  onDocumentClick(event) {
    const isClosest = event.target.closest("choose-size");

    if (!isClosest && this.classList.contains(this.openClass)) {
      this.classList.remove(this.openClass);
    }
  }

  hideAllLists() {
    document.querySelectorAll("choose-size").forEach((chooseSize) => {
      chooseSize.classList.remove(this.openClass);
    });
  }

  showList() {
    this.classList.add(this.openClass);
  }
}

customElements.define("choose-size", ChooseSize);